const processInstance = {
    processesList: [],
    processInspectorById: {}
};

export default processInstance;
